import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
    setStudySessionBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    studySessionsRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const StudySession = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    const { studyModuleAccess } = packageSettings
    const moduleAccess = studyModuleAccess === YES && moduleList[moduleIds.study].status === ACTIVE

    const baseRouteMask = `${projectBaseRoute}${studySessionsRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${studySessionsRoute}`

    useEffect(() => {
        dispatch(setStudySessionBaseRoute(baseRoute))
    }, [])

    if (!moduleAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:sessionId`}
                component={View}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:sessionId`}
                component={Edit}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default StudySession
